import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-tcg-traceability-modal",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./tcg-traceability-modal.component.html",
  styleUrl: "./tcg-traceability-modal.component.scss",
})
export class TcgTraceabilityModalComponent {
  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;
  @Input() data: any;
  @Input() title: any = "";

  getCoveredCriteria(data: any): { items: string[]; numbered: boolean } {
    if (!data?.traceability) {
      return { items: [], numbered: false };
    }

    let text = String(data.traceability);
    const storyKey = data?.key ? String(data.key) : '';
    if (storyKey) {
      const escapedKey = storyKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      text = text.replace(new RegExp(`${escapedKey}\\s*:?`, 'gi'), '');
    }

    const rawItems = text
      .split(/#|\|\|/)
      .map(item => this.cleanListItem(item))
      .filter(item => {
        if (!item) return false;
        if (!storyKey) return true;
        return item.toLowerCase() !== storyKey.toLowerCase();
      });

    const numbered = rawItems.length > 0 && rawItems.every(item => /^\d+\./.test(item));
    const items = numbered
      ? rawItems.map(item => item.replace(/^\d+\.\s*/, '').trim()).filter(Boolean)
      : rawItems;

    return { items, numbered };
  }

  private cleanListItem(item: string): string {
    return item.replace(/^[\s,]+|[\s,]+$/g, '').trim();
  }
}
